import "./App.css"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import history from "./utils/History"
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom"
import { observer } from "mobx-react-lite"
import Login from "./screens/Login"
import Dashboard from "./screens/Dashboard"
import Download from "./screens/Download"
import Products from "./screens/Products"
import { authStore } from "./utils/AuthStore"
import "./App.less"

function App() {
	const RequireAuth = (props) => (authStore.authenticated === true ? props.children : <Navigate to="/login" />)

	return (
		<HistoryRouter history={history}>
			<Routes>
				<Route path="/download" element={<Download />} />
				<Route
					path="/products"
					element={
						<RequireAuth>
							<Products />
						</RequireAuth>
					}
				/>
				<Route path="/login" element={<Login />} />
				<Route path="/" element={<Navigate to="/download" />} />
				<Route
					path="/dashboard"
					element={
						<RequireAuth>
							<Dashboard />
						</RequireAuth>
					}
				/>
			</Routes>
		</HistoryRouter>
	)
}

export default observer(App)
